import { Checkbox } from '@/components/ui/checkbox';
import { ColumnDef } from '@tanstack/react-table';
import { format } from 'date-fns';
import { Translator } from '../translator.type';

export type ReceiverToAdd = {
  id: string;
  name: string;
  country: string;
  createdAt: string;
};

export const RECEIVER_TO_ADD_COLUMNS = (
  t: Translator,
): ColumnDef<ReceiverToAdd>[] => [
  {
    id: 'select',
    header: ({ table }) => (
      <Checkbox
        checked={
          table.getIsAllPageRowsSelected() ||
          (table.getIsSomePageRowsSelected() && 'indeterminate')
        }
        onCheckedChange={(value) => table.toggleAllPageRowsSelected(!!value)}
        aria-label="Select all"
      />
    ),
    cell: ({ row }) => (
      <Checkbox
        checked={row.getIsSelected()}
        onCheckedChange={(value) => row.toggleSelected(!!value)}
        aria-label="Select row"
      />
    ),
    enableSorting: false,
    enableHiding: false,
  },
  {
    accessorKey: 'name',
    header: t('receivers.columns.name'),
  },
  {
    accessorKey: 'country',
    header: t('receivers.columns.country'),
  },
  {
    accessorKey: 'createdAt',
    header: t('receivers.columns.createdAt'),
    cell: ({ row }) => (
      <span>{format(new Date(row.original.createdAt), 'dd/MM/yyyy')}</span>
    ),
  },
];
